import { render, staticRenderFns } from "./GameSharing.vue?vue&type=template&id=5cf0c592&scoped=true&"
import script from "./GameSharing.vue?vue&type=script&lang=js&"
export * from "./GameSharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0c592",
  null
  
)

export default component.exports